import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import { updateFirstStepDynamicFields } from "../../../../../../../redux/reducers/claimReducer";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import WholeLineContainer from "../../../../../../../Components/ReportFormTemplate/WholeLineContainer";
import CustomTextarea from "../../../../../../../Components/CustomInputs/CustomTextarea";
import { useScrollToTopErrorInput } from "../../../../../../../CustomHooks/useScrollToTopErrorInput";

const InjuryAdditionalInjuryDescriptionField: React.FC = () => {
   const dispatch = useDispatch();

   const AdditionalInjuryDescriptionValueInjury = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
            (model) => model.typeOfClaimEnum === 0
         )?.additionalInjuryDescription
   );
   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );

   return (
      <WholeLineContainer
         dependencyValue={shouldRenderSpecField(
            "injury",
            "AdditionalInjuryDescription",
            visibilityMatrixes
         )}
      >
         <CustomTextarea
            labelText="Podrobný popis vzniku úrazu, či nemoci"
            name="AdditionalInjuryDescription"
            value={AdditionalInjuryDescriptionValueInjury || ""}
            onChange={(e) => {
               dispatch(
                  updateFirstStepDynamicFields({
                     value: e.target.value.slice(0, 240),
                     field: "dateOfClaimTo",
                     typeOfClaimEnum: 0,
                  })
               );
            }}
            validationText={handleShowErrorMessage(
               "injury.AdditionalInjuryDescription",
               claimFieldErrorsMessages
            )}
            placeholderText="Popište co nejpodrobněji"
            maxCharacters="240"
            highlightMaxCharacters={
               AdditionalInjuryDescriptionValueInjury?.length === 240
            }
         />
      </WholeLineContainer>
   );
};

export default InjuryAdditionalInjuryDescriptionField;
